import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import { PricebookListPage, PricebookEditPage, PricebookCreatePage } from './imports';

export const pricebookRoutes = [
  {
    path: 'pricebook',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PRICEBOOK}
            access={OrionAccess.VIEW}
          >
            <PricebookListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PRICEBOOK}
            access={OrionAccess.VIEW}
          >
            <PricebookListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PRICEBOOK}
            access={OrionAccess.CREATE}
          >
            <PricebookCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PRICEBOOK}
            access={OrionAccess.UPDATE}
          >
            <PricebookEditPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
